import React from 'react'

const ExcelButton = ({ onClick, width = 25, height = 25, buttonText = "Excel'e Aktar" }) => {
  return (
    <a onClick={onClick} className='excel-button ms-2 d-flex justify-content-center align-items-center'>
      <img
        src='/images/icons/excel.png'
        alt=''
        width={width}
        height={height}
        style={{ cursor: 'pointer', marginRight: '5px' }}
        title="Excel'e Aktar"
      />
      {buttonText}
    </a>
  )
}

export default ExcelButton
